/* eslint-disable simple-import-sort/imports */

// NOTE: this file is a workaround for CSS ordering build issue, keep the above ESLint disable
// NOTE: don't add more stuff to this one and don't import Cashup component directly in other places
// NOTE: this file is also a workaround for loading data first time the Cashup is rendered

import 'styles/cashup/index.scss';

const CashupStylesImporter = ({ children }) => <>{children}</>;

export default CashupStylesImporter;
